import { render, staticRenderFns } from "./OhsDisplaySection.vue?vue&type=template&id=b46827da"
import script from "./OhsDisplaySection.vue?vue&type=script&lang=ts"
export * from "./OhsDisplaySection.vue?vue&type=script&lang=ts"
import style0 from "./OhsDisplaySection.vue?vue&type=style&index=0&id=b46827da&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports